import styled from "styled-components";
export const MainContainer = styled.div`
  overflow: auto;
`;

export const ContentContainer = styled.div`
  display: flex;
  flex-direction: row;
  padding: 1%;
`;

export const RightButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  width: 25%;
  height: 20%;
`;

export const ContainerInformationImport = styled.div`
  margin-top: 50px;
`;

export const InformationsDados = styled.div`
  padding: 40px;
  border-radius: 10px;
  color: white;
  background-color: #2e2e2e;
`;
export const BlockDiviser = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: 25px;
`;

export const TextInformation = styled.p`
  font-family: IBM Plex Mono;
  font-size: 16px;
  font-weight: 400;
  margin: 2px;
`;

export const GeneralContainer = styled.div<{ width?: string }>`
  width: ${(props) => (props.width ? `${props.width}` : "100%")};
  padding-right: 10px;
  padding-left: 10px;
`;

export const FileImportTableContainer = styled.div`
  overflow-y: scroll;
  height: 400px;
  margin-bottom: 20px;
  padding-right: 10px;
  padding-left: 10px;
  
  ::-webkit-scrollbar {
    width: 5px;
  }

  ::-webkit-scrollbar-track {
    box-shadow: inset 0 0 5px #E0F0F5; 
    border-radius: 8px;
  }

  ::-webkit-scrollbar-thumb {
      background: #556ED1; 
      border-radius: 5px;
  }

  @media (max-width: 700px){
    overflow-x: scroll;

    ::-webkit-scrollbar {
      display: none;
    }
    
  }

`